<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
    <linearGradient
      v-if="gradientOn"
      id="gradient"
      gradientUnits="userSpaceOnUse"
      x1="46.058"
      y1="143.138"
      x2="113.743"
      y2="25.904"
    >
      <stop offset="0" stop-color="#db6b00" />
      <stop offset="1" stop-color="#f7902d" />
    </linearGradient>
    <g :fill="changeColor">
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    gradientOn: Boolean
  },
  computed: {
    changeColor() {
      return this.gradientOn === false ? "#fff" : "url(#gradient)";
    }
  }
};
</script>
